import React, { FC } from 'react';
import {
  EddShortSteps, EddSteps,
} from '../../constants';
import { PageHeader } from '../PageHeader';
import styles from './index.module.css';

interface FormContentLayoutProps {
    /** 内容标题 */
    title: string;
    /** 内容描述 */
    description: string;
    /** 具体的表单控件 */
    children: React.ReactNode;
    /** 当前步骤 */
    step?: EddSteps | EddShortSteps;
    /** 数据充足或者不充足 */
    dataSufficient?: boolean;
}

const FormContentLayout: FC<FormContentLayoutProps> = ({
  title, description, children, step = EddSteps.FIRST, dataSufficient = false,
}) => (
  <div className={styles.formContentLayout}>
    <PageHeader />
    <div className={styles.step}>
      Step
      {' '}
      <span className={styles.currentStep}>{step}</span>
      {' '}
      of
      {' '}
      {dataSufficient ? 2 : 5}
    </div>
    <div className={styles.title}>{title}</div>
    <div className={styles.description}>{description}</div>
    {children}
  </div>
);

export { FormContentLayout };
